var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Container, Row, Col } from '../../../uikit/grid';
import { Spacer } from '../../../uikit/misc/Spacer';
import { MAIN_FORM_PAGE__LAYOUT_GRID } from '../../../pages/MainFormPage/config';
export var MainFormLayout = function (props) {
    var children = props.children;
    return (React.createElement(Container, null,
        React.createElement(Row, null,
            React.createElement(Col, __assign({}, MAIN_FORM_PAGE__LAYOUT_GRID),
                React.createElement(Spacer, { size: 4 }),
                children,
                React.createElement(Spacer, { size: 5 })))));
};
